import { markMainEnd } from '@src/slide/infrastructure/module/dependent/performance/js-run-point';
import TocAppStarter from './toc-app-starter';

new TocAppStarter();

markMainEnd();
